export default __webpack_public_path__ + "static/media/9.6869ebb2.svg";